<template>
  <!-- 案例及应用 -->
  <div>
    <!-- PC端 -->
    <div class="case" v-if="webFlag">
      <!-- 头部 -->
      <head-nav :selectedId="2"></head-nav>
      <img src="../assets/images/banner06.png" alt="" style="width: 100%" />
      <el-container>
        <el-aside width="100%">
          <title-com :name="'案例及应用'" :letter="'PROJECT CASES'"></title-com>
          <div class="wrap" v-if="caseFlag1">
            <div
              class="case_item"
              v-for="(item, i) in sampleList"
              :key="i"
              @click="caseDetailsEvent(item.id)"
            >
              <img :src="item.url" alt="" />
              <div class="school_name">{{ item.title }}</div>
              <div class="marsk"></div>
            </div>
          </div>
          <div class="case-details" v-if="caseFlag2">
            <div class="back" @click="backEvent">返回列表</div>
            <div class="title">{{ caseDetails.title }}</div>
            <img :src="caseDetails.url" alt="" />
            <div v-html="caseDetails.content" class="content"></div>
            <div class="next">
              <p @click="lastEvent">上一条案例</p>
              <p @click="nextEvent">下一条案例</p>
            </div>
          </div>
        </el-aside>
      </el-container>
      <!-- 尾部 -->
      <footer-com />
    </div>
    <!-- 移动端 -->
    <div class="solution" v-if="mobilPhoneFlag">
      <!-- 头部 -->
      <mobileHead></mobileHead>
      <img
        src="@/assets/images/banner06.png"
        alt=""
        class="banner"
        style="width: 100%; margin: 44px 0"
      />
      <el-container>
        <el-aside width="100%">
          <title-com :name="'案例及应用'" :letter="'PROJECT CASES'"></title-com>
          <div class="wrap" v-if="caseFlag1">
            <div
              class="case_item"
              v-for="(item, i) in sampleList"
              :key="i"
              @click="caseDetailsEvent(item.id)"
            >
              <img :src="item.url" alt="" />
              <div class="school_name">{{ item.title }}</div>
              <div class="marsk"></div>
            </div>
          </div>
          <div class="case-details" v-if="caseFlag2">
            <div class="back" @click="backEvent">返回列表</div>
            <div class="title">{{ caseDetails.title }}</div>
            <img :src="caseDetails.url" alt="" />
            <div v-html="caseDetails.content" class="content"></div>
            <div class="next">
              <p @click="lastEvent">上一条案例</p>
              <p @click="nextEvent">下一条案例</p>
            </div>
          </div>
        </el-aside>
      </el-container>
      <!-- 尾部 -->
      <mobile-footer></mobile-footer>
    </div>
  </div>
</template>

<script>
import headNav from "@/components/header.vue";
import footerCom from "@/components/footer.vue";
import titleCom from "@/components/title.vue";
// 移动端组件
import mobileHead from "@/components/publicCom/mobileHead.vue";
import mobileFooter from "@/components/publicCom/mobileFooter.vue";
export default {
  components: {
    headNav,
    footerCom,
    titleCom,
    mobileHead,
    mobileFooter,
  },
  data() {
    return {
      webFlag: true,
      mobilPhoneFlag: false,
      sampleList: "",
      caseDetails: "",
      caseFlag1: true,
      caseFlag2: false,
      nowId: "",
    };
  },

  mounted() {
    this.getScreenWidth();
    this.getListSampleAll();
  },
  methods: {
    // 获取设备宽度
    getScreenWidth() {
      console.log(document.body.offsetWidth, window.screen.availWidth);
      if (window.screen.availWidth <= 1366) {
        this.webFlag = false;
        this.mobilPhoneFlag = true;
        console.log(window.screen.availWidth);
      }
    },
    // 获取案例列表
    getListSampleAll() {
      this.$axios
        .get("/content/sample/listAll")
        .then((res) => {
          console.log(res);
          this.sampleList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 案例详情
    caseDetailsEvent(id) {
      console.log(id);
      this.caseFlag1 = false;
      this.caseFlag2 = true;
      this.nowId = id;
      this.$axios.get("/content/sample/getSampleInfo/" + id).then((res) => {
        console.log(res);
        this.caseDetails = res.data;
      });
    },
    // 返回列表
    backEvent() {
      this.caseFlag1 = true;
      this.caseFlag2 = false;
    },
    // 上一个
    lastEvent() {
      for (let i in this.sampleList) {
        if (this.nowId == this.sampleList[i].id) {
          if (i == 0) {
            this.$message({
              type: "warning ",
              message: "已经是第一条案例了",
            });
          } else {
            let id = this.sampleList[i - 1].id;
            console.log(id);
            this.$axios
              .get("/content/sample/getSampleInfo/" + id)
              .then((res) => {
                console.log(res);
                this.caseDetails = res.data;
                this.nowId = res.data.id;
              });
          }
        }
      }
    },
    // 下一个
    nextEvent() {
      for (let i in this.sampleList) {
        if (this.nowId == this.sampleList[i].id) {
          if (i == this.sampleList.length - 1) {
            this.$message({
              type: "warning ",
              message: "已经是最后一条案例了",
            });
          } else {
            let index = Number(i) + 1;
            let id = this.sampleList[index].id;
            this.$axios
              .get("/content/sample/getSampleInfo/" + id)
              .then((res) => {
                this.caseDetails = res.data;
                this.nowId = res.data.id;
              });
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1367px) {
  .el-container {
    margin: 40px 180px;
    .wrap {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      .case_item {
        width: 480px;
        margin-bottom: 50px;
        background: #fff;
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #808080;
        box-shadow: -1px 7px 13px 0px rgba(24, 24, 24, 0.11);
        img {
          width: 100%;
          height: 279px;
        }
        .school_name {
          width: 100%;
          height: 75px;
          line-height: 75px;
        }
      }
      .case_item:hover {
        background: #3660d9;
        color: #fff;
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .wrap {
    background: #fff;
    padding: 58px 40px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .case_item {
      width: 325px;
      margin-bottom: 50px;
      background: #fff;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #808080;
      box-shadow: -1px 7px 13px 0px rgba(24, 24, 24, 0.11);
      border-radius: 5px;

      img {
        width: 100%;
        height: 183px;
      }
      .school_name {
        width: 100%;
        height: 49px;
        line-height: 49px;
        font-size: 18px;
      }
    }
  }
}
.case-details {
  background: #fff;
  padding: 40px;
  img {
    margin: 20px 0;
  }
  .back {
    color: blue;
    text-align: left;
    margin: 20px 0;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
  }
  .content {
    width: 100%;
    height: 100px;
    font-size: 16px;
    color: #999;
  }
  .next {
    text-align: left;
    color: rgb(53, 128, 241);
    p {
      margin: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/caseAndUse.vue